import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { RowElement } from '@framework/ui/components/row/RowElement.tsx';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact.ts';
import { RuleType } from '../../IRule.ts';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage.tsx';

const fieldName = `rules.${RuleType.RepeatableRange}`;

export interface IRepeatableRangeRuleComponentProps {}

export function RepeatableRangeRuleComponent(
  props: IRepeatableRangeRuleComponentProps,
) {
  // const {} = props;
  return (
    <RowElement>
      <FormItem
        name={`${fieldName}.min`}
        label="Ripetizioni Minime"
        help="Numero minimo di ripetizioni."
      >
        <$SpaceCompact block size="large">
          <NumberInput name={`${fieldName}.min`} />
          <CustomValidationRuleMessage name={`${fieldName}.minCustomMessage`} />
        </$SpaceCompact>
      </FormItem>

      <FormItem
        name={`${fieldName}.max`}
        label="Ripetizioni Massime"
        help="Numero massimo di ripetizioni."
      >
        <$SpaceCompact block size="large">
          <NumberInput name={`${fieldName}.max`} />
          <CustomValidationRuleMessage name={`${fieldName}.maxCustomMessage`} />
        </$SpaceCompact>
      </FormItem>
    </RowElement>
  );
}
